import React, { useEffect, useLayoutEffect, useRef } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import { useForm, Controller } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import * as z from 'zod';
import { t } from 'components/Common/Translations';
import { UserDto } from 'models';
import Select from 'react-select';

export interface IAdminUserForm {
    email?: string;
    firstName?: string;
    lastName?: string;
    userId?: number;
}

interface IAdminUserFormProps {
    title?: string;
    editedItem?: IAdminUserForm;
    cancel: () => void;
    //ok: () => void;
    submit: (data: IAdminUserForm) => void;
    users: UserDto[] | null;
}

const validationSchema = z.object({
    // filename: z.string().trim().min(1),
});

export function AdminUserForm(props: IAdminUserFormProps) {
    const cancel = () => props.cancel();

    const {
        register, handleSubmit, reset, formState: { errors }, control, watch, setFocus,
    } = useForm<IAdminUserForm>({
        // resolver: zodResolver(validationSchema),
        //defaultValues: props.editedItem,
        defaultValues: {},
        values: props.editedItem || {},
        resetOptions: {
            keepDirtyValues: true,
            keepErrors: true, // input errors will be retained with value update
        }
    });

    useLayoutEffect(() => {
        setTimeout(() => {
            setFocus('email', { shouldSelect: true });
        }, 0);
    }, [setFocus]);

    return (
        <>
            <Modal show={true} onHide={cancel} size='lg'>
                <Form onSubmit={handleSubmit(props.submit)}>
                    <Modal.Header closeButton>
                        <Modal.Title>{props.title ?? t("Ny användare")}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {props.users?.length > 0 && (
                            <>
                                <p>Välj en befintlig användare, eller skapa en ny genom att ange epost och namn.</p>
                                <Form.Group className={`mb-3`} controlId="formUserId" >
                                    <Form.Label>Befintlig användare</Form.Label>

                                    <Controller
                                        control={control}
                                        name="userId"
                                        render={({
                                            field: { onChange, onBlur, value: formFieldValue, name, ref },
                                            fieldState: { invalid, isTouched, isDirty, error },
                                            formState,
                                        }) => {
                                            return (
                                                <Select
                                                    value={props.users?.find((u) => u.id == formFieldValue)}
                                                    onChange={(newValue) => onChange(newValue?.id)}
                                                    options={props.users}
                                                    getOptionLabel={val => `${val.fullName} (${val.email})`}
                                                    //formatOptionLabel={(data, x) => {return <div style={{display: "flex", justifyContent: "space-between"}}><div>{data.fullName}</div><div>{data.email}</div></div>}}
                                                    getOptionValue={val => val.id.toFixed()}
                                                    className='react-select'
                                                    isClearable
                                                />
                                            );
                                        }}
                                    />
                                </Form.Group>
                            </>)}

                        <Form.Group className={`mb-3 ${errors.email ? 'is-invalid' : ''}`} controlId="formEmail">
                            <Form.Label>{t('Epost')}</Form.Label>

                            <Form.Control {...register('email')} />

                            {errors.email && (
                                <Form.Control.Feedback type="invalid" className='d-block'>Detta fält är obligatoriskt.</Form.Control.Feedback>
                            )}
                        </Form.Group>

                        <Form.Group className={`mb-3 ${errors.firstName ? 'is-invalid' : ''}`} >
                            <Form.Label>{t('Förnamn')}</Form.Label>

                            <Form.Control {...register('firstName')} />

                            {errors.firstName && (
                                <Form.Control.Feedback type="invalid" className='d-block'>Detta fält är obligatoriskt.</Form.Control.Feedback>
                            )}
                        </Form.Group>

                        <Form.Group className={`mb-3 ${errors.lastName ? 'is-invalid' : ''}`} >
                            <Form.Label>{t('Efternamn')}</Form.Label>

                            <Form.Control {...register('lastName')} />

                            {errors.lastName && (
                                <Form.Control.Feedback type="invalid" className='d-block'>Detta fält är obligatoriskt.</Form.Control.Feedback>
                            )}
                        </Form.Group>

                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={cancel}>
                            Stäng
                        </Button>
                        <Button variant="primary" type="submit">
                            Spara
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </>
    );
}
